import { render, staticRenderFns } from "./PurchasesInvoices.vue?vue&type=template&id=54519375"
import script from "./PurchasesInvoices.vue?vue&type=script&lang=js"
export * from "./PurchasesInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports